import fondo from '../img/fond.webp';
import { useState } from 'react';
import '../css/paginasClientes.css'
import foto from '../img/ChatGPT_Image_25_mar_2026__07_06_33_p.m.-removebg-preview.webp'
import foto1 from '../img/Captura de pantalla 2026-03-20 202513 (1).png'
import foto2 from '../img/Captura de pantalla 2026-03-20 202548.png'
import foto3 from '../img/Captura de pantalla 2026-03-20 202713.png'
import foto4 from '../img/Captura de pantalla 2026-03-20 202619.png'

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";   // 👈 necesario para flechas
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/swiper-bundle.css";

import { Navigation, FreeMode, Thumbs } from 'swiper/modules';



const TeatroColon = () => {

  const images = [
    foto,
    foto4,
    foto1,
    foto2, 
    foto3

  ]

  const [thumbsSwiper, setThumbsSwiper] = useState(null);


  return (
    <div className='paginasContainer' id='teatroColon'>
      <img src={fondo} className='fondoPaginas' alt='fondo' />
      <h3>Aplicación web desarrollada para el Teatro Colón</h3>
      <div className="gallery-section">

        {/* SLIDER PRINCIPAL */}
        <Swiper
          spaceBetween={10}
          navigation={true}
          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
          modules={[Navigation, Thumbs]}
          className="main-swiper"
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img src={src} alt={`Slide ${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* MINIATURAS */}
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={4}
          modules={[Thumbs]}
          className="thumbs-swiper"
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img src={src} alt={`Slide ${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
      <p className='parrafoClientes'>
       Se diseñó y desarrolló una aplicación web a medida para el sector de herrería del Teatro Colón, con el objetivo de optimizar la gestión interna de materiales, herramientas y proyectos. La plataforma incorpora un sistema de login seguro que permite el acceso controlado de usuarios, garantizando la protección de la información y la administración diferenciada según roles.

La aplicación permite gestionar el stock de caños y otros insumos, registrar las máquinas disponibles y llevar un control detallado de las obras en curso. Además, cuenta con un sistema de control y administración de bases de datos que centraliza toda la información operativa, facilitando la actualización, consulta y trazabilidad de los recursos utilizados.

También posibilita el seguimiento preciso de qué materiales y herramientas se emplearon en cada producción, mejorando la organización del trabajo diario y reduciendo errores. La interfaz fue diseñada para ser clara, intuitiva y funcional, con el objetivo de agilizar las tareas operativas y brindar un entorno digital eficiente, accesible y escalable para la gestión interna.</p>
      
      
    </div>
  )
}

export default TeatroColon